module.exports = __webpack_public_path__ + "img/num_40.262f0579.png";